import React, { useState } from 'react';
import Modal from '../Modal';
import { AuthModalProps } from './AuthModal.types';
import EntryScreen from './components/EntryScreen';
import RemindPassword from './components/RemindPassword';
import styles from './AuthModal.module.css';

const AuthModal = ({ onClose, entryPoint }: AuthModalProps) => {
  const [modalState, setModalState] = useState('entry');

  return (
    <Modal onClose={onClose} useCloseBtn={false}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.left_side}>
            <div className={styles.left_logo} />
          </div>
          <div className={styles.right_side}>
            {modalState === 'entry' && (
              <EntryScreen
                setModalState={setModalState}
                onClose={onClose}
                entryPoint={entryPoint}
              />
            )}
            {modalState === 'remind' && (
              <RemindPassword
                setModalState={setModalState}
                onClose={onClose}
                entryPoint={entryPoint}
              />
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AuthModal;
